var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddressProof(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "f961e5df64887ebd9007eb03a1022753",
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148128",
    "data-name": "Rectangle 148128",
    width: 61,
    height: 61,
    transform: "translate(0.5 0.5)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1469",
    "data-name": "Path 1469",
    d: "M90.347,197.28l5.742-5.742a3.826,3.826,0,0,1,5.413,0l5.742,5.742h12.6a5.74,5.74,0,0,1,5.742,5.742v26.795a5.744,5.744,0,0,1-5.742,5.742H77.742A5.744,5.744,0,0,1,72,229.817V203.022a5.741,5.741,0,0,1,5.742-5.742Zm4.471,22.215a3.829,3.829,0,0,0-3.755-3.076H82.718a3.828,3.828,0,0,0-3.753,3.076c-.31,1.552-.794,3.966-1.148,5.742a3.827,3.827,0,0,0,3.753,4.58H92.211a3.83,3.83,0,0,0,3.755-4.58Zm5.891.752h13.4a1.914,1.914,0,0,0,0-3.828h-13.4a1.914,1.914,0,1,0,0,3.828ZM86.89,203.022a5.742,5.742,0,1,0,5.742,5.742A5.744,5.744,0,0,0,86.89,203.022Zm13.818,11.483h17.225a1.914,1.914,0,0,0,0-3.828H100.709a1.914,1.914,0,1,0,0,3.828Z",
    transform: "translate(-68.172 -181.969)",
    fill: "#d7dbdc",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressProof);
export default __webpack_public_path__ + "static/media/addressProof.f6714bbe4bf44a6c8355ce16ecf39571.svg";
export { ForwardRef as ReactComponent };